
import { KoDate, KoForm, KoFormBuilder, KoLoader, KoSelect, KoTextArea} from 'packages';
import { AssetsAPI } from 'pages/workspace/process/assets/assets.service';
import React, { useCallback, useEffect, useState } from 'react';
import styles from './retainerInvoices.module.scss';
import ItemEntryCrud from './itemEntryCrud';





const RetainerInvoicesCurd = ({form, handleFinish, initialValues }) => {
  // const [form] =KoForm.useForm();
  const [customersList, setDataList] = useState();
  const [isLoading, setLoading] = useState(false);


  useEffect(() => {
    getClients();
  }, []);

  const getClients = () => {
    setLoading(true);
    AssetsAPI.getClients().then(
      (data) => {
        setLoading(false);
        setDataList(data['customers']);
      },
      (err) => {
        setLoading(false);
      }
    );
  };
  const Customers = ({ value, onChange }) =>
    <KoSelect
      value={value}
      showSearch
      mode="multiple"
      optionFilterProp="label"
      placeholder="Select customer"
      onChange={onChange}
      options={customersList?.map(cus => ({
        label: cus?.companyName || 'Unnamed Customer',
        value: cus?.customerId
      }))}
      loading={!customersList?.length}
    />;

  const Date = ({ value, onChange }) => {
    return (
      <KoDate
        value={value}
        format={'DD-MMM-YYYY'}
        daysAgo={0}
        onChange={v => onChange(v)}
      />
    );
  };


  const person = [
    { label: 'ProjectKamel', value: 'projectkamel' },
    { label: 'ProjectNithish', value: 'projectnithish' },
    { label: 'ProjectSam', value: 'projectsam' },
    { label: 'ProjectRaji', value: 'projectraji' }
  ];
      
  const Salesperson= ({ value, onChange }) =>
    <KoSelect value={value}
      onChange={v => onChange(v)}
      showSearch
      allowClear
      placeholder='Choose a Project'
      options={person?.map((value) => ({
        label: value.label,
        value: value?.value
      }))}
    />;

  const meta = {
    columns: 4,
    formItemLayout: null,
    initialValues: {},
    colon: true,
    fields: [
      { key: 'customer', label: 'Customer Name', colSpan: 2, widget: Customers },
      { key: 'reference', placeholder: 'Retainer Invoice Number', label: 'Reference#' , colSpan: 2},
      { key: 'reference', placeholder: 'Project a Reference', label: 'Reference#' , colSpan: 2},
      { key: 'startDate', label: 'Retainer Invoice Date', colSpan: 2, widget: Date },
      { key: 'projectname', label: 'Project Name', colSpan: 2, widget:Salesperson   },
      { key: '', label: 'Item Table', colSpan: 6, widget: () => <ItemEntryCrud form={form} handleFinish={handleFinish} initialValues={initialValues} /> },
      { key: 'description', widget: KoTextArea, label: 'Customer Notes', colSpan: 6, placeholder: 'Will be displayed on purchase order'},
      { key: 'termscondition', widget: KoTextArea, label: 'Terms & Conditions', colSpan: 6, placeholder: 'Enter the terms and conditions of your business to be displayed in your transaction'}
    ]};




  const handleSubmit =useCallback((values)=>{
    console.log(values);
  },[form]);


  
  return (
    <div  className={styles.wrapper}>
      {isLoading&& <KoLoader/>}
      <KoForm  form={form} layout="vertical" onFinish={handleSubmit} onSubmit={handleSubmit} >
        <KoFormBuilder form={form} meta={meta} />
      </KoForm></div>
  );
};
export default RetainerInvoicesCurd;